// 账户管理
import accountManage from '@/views/accountManage/accountManage'
import projectManage from '@/views/accountManage/projectManage'
import createProject from '@/views/accountManage/createProject'
import authCallback from '@/views/accountManage/authCallback'
import putInAccountManage from '@/views/accountManage/putInAccountManage'
import staffManage from '@/views/accountManage/staffManage'
import agentManage from '@/views/accountManage/agentmanage/index'
import roleManage from '@/views/accountManage/roleManage'
export default {
  path: '/qianchuan/account',
  name: 'account',
  component: accountManage,
  meta: {
    keepAlive: true,
    title: '账户管理',
    code: 'page:accountManage',
    activeName: '/account',
    permission: 'account',
    name: 'account'
  },
  children: [
    {
      path: 'project',
      name: 'qcproject',
      component: projectManage,
      meta: {
        keepAlive: true,
        title: '项目管理',
        iconName: 'icon-menuXm',
        permission: 'projectManagement'
      },
      children: [
        {
          path: 'createProject',
          name: 'qccreateProject',
          component: createProject,
          meta: {
            keepAlive: true
          }
        }
      ]
    },
    {
      path: 'qcputInAccount',
      name: 'qcputInAccount',
      component: putInAccountManage,
      meta: {
        keepAlive: true,
        title: '投放账户管理',
        iconName: 'icon-menuTf',
        permission: 'accountManagement'
      },
      children: [
        {
          path: '/qianchuan/account/authCallback',
          name: 'qcauthCallback',
          component: authCallback,
          meta: {
            keepAlive: false
          }
        }
      ]
    },
    {
      path: 'staff',
      name: 'staff',
      component: staffManage,
      meta: {
        keepAlive: true,
        title: '员工管理',
        iconName: 'icon-menuYg',
        permission: 'employeeManagement'
      },
      children: [
        {
          path: 'create',
          name: 'qccreateEmployees',
          component: resolve => require(['@/views/accountManage/createEmployees'], resolve),
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'modify',
          name: 'qcmodifyEmployees',
          component: resolve => require(['@/views/accountManage/modifyEmployees'], resolve),
          meta: {
            keepAlive: true
          }
        }
      ]
    },
    {
      path: 'agent',
      name: 'agent',
      component: agentManage,
      meta: {
        keepAlive: true,
        title: '代理商管理',
        iconName: 'icon-dailishangguanli',
        permission: 'agencyManagement'
      }
    },
    {
      path: 'role',
      name: 'role',
      component: roleManage,
      meta: {
        keepAlive: true,
        title: '角色权限管理',
        iconName: 'icon-roleManage',
        permission: 'role:list'
      },
      children: [
        {
          path: 'roleAuthorization',
          name: 'qcroleAuthorization',
          component: resolve => require(['@/views/accountManage/roleAuthorization'], resolve),
          meta: {
            keepAlive: true,
            title: '角色授权'
          }
        }
      ]
    }
    // {
    //   path: 'filterwords',
    //   name: 'qcfilterwords',
    //   component: resolve => require(['@/views/material/filterwordsLibrary'], resolve),
    //   meta: {
    //     keepAlive: true,
    //     title: '屏蔽词库',
    //     iconName: 'icon-cidian',
    //     permission: 'blackWord'
    //   }
    // }
  ]
}



// WEBPACK FOOTER //
// ./src/router/qianchuan/account.js